import { FC, useState } from 'react';
import { Grid, Alert } from '@mui/material';
import { useGuardianState } from '../../contexts/guardian.context';
import { useTranslation } from 'src/hooks/useTranslationHook';
import ConcernsView from '../../../communications/subviews/concerns/ConcernsView.view';
import RaiseConcernForm from '../../../communications/subviews/concerns/components/RaiseConcernForm.view';
import { useCreateConcernHook } from '../../../communications/hooks/useConcernsHook';
import { CreateConcernPayload } from '../../../../../apis/messaging/messaging.interfaces';

const GuardianConcernsView: FC = () => {
  const { translateText } = useTranslation();
  const { selectedChildId } = useGuardianState();
  const [formOpen, setFormOpen] = useState(false);

  const createMutation = useCreateConcernHook();
  const err = createMutation.error as
    | { response?: { data?: { message?: string } }; message?: string }
    | undefined;
  const errorMessage = err?.response?.data?.message ?? err?.message;

  const handleSubmit = (data: CreateConcernPayload) => {
    createMutation.mutate(
      { ...data, student_id: selectedChildId || undefined },
      {
        onSuccess: () => {
          setFormOpen(false);
        },
      }
    );
  };

  if (!selectedChildId) {
    return (
      <Grid container spacing={3} sx={{ p: 3 }} data-testid="guardian-concerns-container">
        <Grid item xs={12}>
          <Alert severity="info">{translateText('guardian.selectChild')}</Alert>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={3} sx={{ p: 3, height: '100%' }} data-testid="guardian-concerns-container">
      <Grid item xs={12} sx={{ height: 'calc(100% - 24px)' }}>
        <ConcernsView
          isGuardian
          studentId={selectedChildId}
          onRaiseConcern={() => setFormOpen(true)}
        />
      </Grid>
      <RaiseConcernForm
        isOpen={formOpen}
        onClose={() => setFormOpen(false)}
        onSubmit={handleSubmit}
        isLoading={createMutation.isPending}
        errorMessage={errorMessage}
        studentId={selectedChildId}
      />
    </Grid>
  );
};

export default GuardianConcernsView;
